import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { DraggableCore, DraggableEventHandler } from 'react-draggable';
import { isPad } from '@/utils/browser-kit';

// 解析CSS位置值的辅助函数
const parsePositionValue = (value: string | number | undefined) => {
    if (value === undefined || value === null) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        if (value === 'auto') return 0;
        const parsed = parseFloat(value);
        return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
};

const DragPopover: React.FC<{
    children?: React.ReactNode;
    handleClassName?: string;
    cancelClassName?: string;
    initialPosition?: Pick<React.CSSProperties, 'top' | 'right' | 'bottom' | 'left'>;
}> = React.memo(({ handleClassName, cancelClassName, children, initialPosition }) => {
    const [position, setPosition] = useState(initialPosition);

    const onDrag: DraggableEventHandler = (_e, data) => {
        setPosition((p) => {
            // 如果没有任何定位属性，默认使用值
            if (!p || (!p.top && !p.right && !p.bottom && !p.left)) {
                return {
                    left: 0,
                    top: 0,
                };
            }

            // 只计算和返回已存在的定位属性
            const result: any = {};

            if (p.top !== undefined) {
                result.top = parsePositionValue(p.top) + data.deltaY;
            }
            if (p.right !== undefined) {
                result.right = parsePositionValue(p.right) - data.deltaX;
            }
            if (p.bottom !== undefined) {
                result.bottom = parsePositionValue(p.bottom) - data.deltaY;
            }
            if (p.left !== undefined) {
                result.left = parsePositionValue(p.left) + data.deltaX;
            }

            return result;
        });
    };

    return createPortal(
        // 如果是iPad设备，不包装Draggable
        isPad ? (
            <div
                style={{
                    position: 'absolute',
                    zIndex: 12,
                    ...position,
                }}
            >
                {children}
            </div>
        ) : (
            <DraggableCore onDrag={onDrag} handle={`.${handleClassName}`} cancel={`.${cancelClassName}`}>
                <div
                    style={{
                        position: 'absolute',
                        zIndex: 12,
                        ...position,
                    }}
                >
                    {children}
                </div>
            </DraggableCore>
        ),
        document.body,
    );
});

export default DragPopover;
